import React from 'react';

function Instructions({ onComplete }) {
  return (
    <div className="phase-container">
      <h1>Instructions</h1>
      
      <div className="instructions-content">
        <h2>Task</h2>
        <p>
          You will compare pairs of images and select which better represents the style of 12 different artists.
          For each artist, you will:
        </p>
        <ol>
          <li>See the artist's name</li>
          <li>Study six example paintings by that artist</li>
          <li>Compare several pairs of images</li>
        </ol>
        <p>Duration: 25-35 minutes</p>

        <h2>How Each Comparison Works</h2>
        <p>When comparing images:</p>
        <ol>
          <li>Examine both images for at least 2 seconds</li>
          <li>Select which image is more characteristic of the artist's style</li>
          <li>Rate your confidence from 1 (very unsure) to 6 (very sure)</li>
          <li>Indicate what mainly influenced your choice</li>
        </ol>

        <p>Base judgments on style characteristics, not personal preference or subject matter appropriateness.</p>

        <h2>What We Mean By "Style"</h2>
        <p>
          Style is the set of visual regularities that characterize an artist's work independent of specific subject matter. 
          When evaluating images, consider these dimensions:
        </p>
        <dl className="style-definitions">
          <dt>Brushwork and Texture</dt>
          <dd>The visible marks, strokes, and surface qualities. This includes how paint is applied—whether thick or thin, smooth or rough, visible brushstrokes or blended surfaces.</dd>
          
          <dt>Color Palette</dt>
          <dd>The selection and relationships between colors. This includes which hues dominate, how saturated or muted colors are, and the contrast between light and dark values.</dd>
          
          <dt>Composition</dt>
          <dd>How elements are arranged within the frame. This includes the placement of objects, the balance between different areas, and the overall structure of the image.</dd>
          
          <dt>Form or Shape Language</dt>
          <dd>How shapes and forms are constructed. This includes whether forms are geometric or organic, simplified or detailed, angular or curved, flat or three-dimensional.</dd>
        </dl>

        <div className="note-box">
          <p>
            There are no correct answers. Make your best judgment for each comparison.
          </p>
        </div>
      </div>
      
      <div className="button-group">
        <button onClick={onComplete}>
          Begin Experiment
        </button>
      </div>
    </div>
  );
}

export default Instructions;